import { all } from 'redux-saga/effects';

//public
import ArticleSaga from './article/saga';
import forgetSaga from './auth/forgetpwd/saga';
import loginSaga from './auth/login/saga';
import ClinicSaga from './clinic/saga';
import HolidaySaga from './holiday/saga';
import TeleconsultSaga from './teleconsult/saga';
import DoctorSaga from './doctor/saga';
import DashboardSaga from './dashboard/saga';
import GeneralSaga from './general/saga';
import LayoutSaga from './layout/saga';
import PatientsSaga from './patients/saga';
import AppointmentsSaga from './appointments/saga';
import MaybankAppointmentsSaga from './maybank/saga';
import ProfileSaga from './profile/saga';
import RoleSaga from './role/saga';
import UserSaga from './user/saga';
import packagesModule from './packages/module';
import packageBookingsModule from './packageBookings/module';
import campaignsModule from './campaigns/module';
import testimonialResponsesModule from './testimonialResponses/module';

//Calendar 
import calendarSaga from "./calendar/saga";

//chat
import chatSaga from "./chat/saga";

export default function* rootSaga() {
    yield all([
        //public
        loginSaga(),
        UserSaga(),
        packagesModule.saga(),
        packageBookingsModule.saga(),
        campaignsModule.saga(),
        testimonialResponsesModule.saga(),
        GeneralSaga(),
        PatientsSaga(),
        AppointmentsSaga(),
        MaybankAppointmentsSaga(),
        DashboardSaga(),
        ClinicSaga(),
        HolidaySaga(),
        TeleconsultSaga(),
        DoctorSaga(),
        RoleSaga(),
        ArticleSaga(),
        ProfileSaga(),
        forgetSaga(),
        LayoutSaga(),
        calendarSaga(),
        chatSaga(),
    ])
}
